module.exports = __webpack_public_path__ + "traumaOne-23ed1baefb7dec0b79bc8d62e9ed8ef9.png";